import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';
import FileRepositoryTreeContainer from './FileRepositoryTreeContainer';
import AddFileModalContainer from './AddFileModalContainer';
import FileRepositoryCategoryModalContainer from './FileRepositoryCategoryModalContainer';
import Button from '../../../core/form/Button';
import FileRepositoryCategoryService from '../services/FileRepositoryCategoryService';
import AddLinkModalContainer from './AddLinkModalContainer';

const FileRepositoryTreeScene = () => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'File Repository',
        },
      ]}
    />
    <Card title="File Repository"
    actions={
      <Button
        key="new_category"
        type="primary"
        icon="plus"
        label="New Category"
        onClick={() =>
          FileRepositoryCategoryService.handleToggleCategoryModal(null)
        }
      />
    }>
      <FileRepositoryTreeContainer />
      <AddFileModalContainer />
      <AddLinkModalContainer />
      <FileRepositoryCategoryModalContainer />
    </Card>
  </div>
);

export default FileRepositoryTreeScene;
